import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RATINGS_TOTAL_STARS } from '@atlassian/amkt-common';
import { formatISO } from 'date-fns';
import React from 'react';
import { JsonLd } from 'react-schemaorg';

/** See https://schema.org/SoftwareApplication */
import { jsx as _jsx } from "react/jsx-runtime";
export const APPLICATION_CATEGORY_ADD_ONS = 'Add-ons';
const AppStructuredData = props => {
  const {
    name,
    icon: image,
    description,
    review: {
      rating: ratingValue,
      count: reviewCount
    },
    partner: {
      name: partnerName,
      url: partnerUrl
    },
    createdAt,
    compatibleProducts
  } = props;
  const app = {
    '@context': 'https://schema.org/',
    '@type': 'SoftwareApplication',
    name,
    image,
    description,
    dateCreated: formatISO(createdAt),
    applicationCategory: APPLICATION_CATEGORY_ADD_ONS,
    applicationSuite: compatibleProducts.map(product => product.name).join(', ')
  };
  if (reviewCount > 0) {
    app.aggregateRating = {
      '@type': 'AggregateRating',
      bestRating: RATINGS_TOTAL_STARS,
      ratingValue,
      reviewCount
    };
  }
  if (partnerName) {
    app.creator = _objectSpread({
      '@type': 'Organization',
      name: partnerName
    }, partnerUrl && {
      url: partnerUrl
    });
  }
  return /*#__PURE__*/_jsx(JsonLd, {
    item: app
  });
};
export default AppStructuredData;